/**
 * @generated SignedSource<<67cb34e2cfb858976266e357dea50c68>>
 * @relayHash 35d23c7e776afd069c2bf80c840d4e1b
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/562.0.0-2026-06-02T14:54:53.634Z/GetHelpZendeskEmbeddedQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskEmbeddedQuery$variables = {
  articleId?: string | null;
  hasSellerId: boolean;
  hasUserId: boolean;
  isLoggedOutUser: boolean;
  isSeller?: boolean | null;
  sellerId: string;
  userId: string;
};
export type GetHelpZendeskEmbeddedQuery$data = {
  readonly viewer: {
    readonly user?: {
      readonly profile: {
        readonly firstName: string | null;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskContactSupport_viewer">;
  };
};
export type GetHelpZendeskEmbeddedQuery = {
  response: GetHelpZendeskEmbeddedQuery$data;
  variables: GetHelpZendeskEmbeddedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "articleId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hasSellerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hasUserId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isLoggedOutUser"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isSeller"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sellerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Profile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sfChatToken",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "touchpoint",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isLiveAgentAvailable",
    "storageKey": null
  }
],
v8 = {
  "kind": "Variable",
  "name": "sellerId",
  "variableName": "sellerId"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetHelpZendeskEmbeddedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "hasUserId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskContactSupport_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetHelpZendeskEmbeddedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "hasUserId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailToken",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "loggedInBuyerSupportChat",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "touchpoint",
                    "value": "Buyer_Messaging"
                  }
                ],
                "concreteType": "SupportChatQuery",
                "kind": "LinkedField",
                "name": "supportChat",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": "supportChat(touchpoint:\"Buyer_Messaging\")"
              }
            ]
          },
          {
            "condition": "isLoggedOutUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "loggedOutBuyerSupportChat",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "touchpoint",
                    "value": "Guest_Buyer_Messaging"
                  }
                ],
                "concreteType": "SupportChatQuery",
                "kind": "LinkedField",
                "name": "supportChat",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": "supportChat(touchpoint:\"Guest_Buyer_Messaging\")"
              }
            ]
          },
          {
            "condition": "hasSellerId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "sellerSupportChat",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "touchpoint",
                    "value": "Seller_Messaging"
                  }
                ],
                "concreteType": "SupportChatQuery",
                "kind": "LinkedField",
                "name": "supportChat",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": "supportChat(touchpoint:\"Seller_Messaging\")"
              },
              {
                "alias": null,
                "args": [
                  (v8/*: any*/)
                ],
                "concreteType": "Seller",
                "kind": "LinkedField",
                "name": "seller",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "isSeller",
                "variableName": "isSeller"
              },
              (v8/*: any*/)
            ],
            "concreteType": "Contact1stdibsZendeskArticles",
            "kind": "LinkedField",
            "name": "zendeskArticles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "articleId",
                    "variableName": "articleId"
                  }
                ],
                "kind": "ScalarField",
                "name": "topicKeyForArticle",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/562.0.0-2026-06-02T14:54:53.634Z/GetHelpZendeskEmbeddedQuery",
    "metadata": {},
    "name": "GetHelpZendeskEmbeddedQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d1e194e66a35196a6c4246e1a8a2bf72";

export default node;
